import React, { Component } from "react";
import { Alert, Col, Divider, message, Popconfirm, Row, Tooltip, Typography } from "antd";
import { QRCode } from "antd5";
import { DeleteOutlined, SafetyCertificateOutlined } from "@ant-design/icons";
import { connect } from "react-redux";
import axios from "axios";
import moment from "moment";
import "moment/locale/es";
import BotonAyudaManuales from "../../../Components/BotonAyudaManuales";
import { ModalItem, ButtonItem, InputItem, SwitchItem } from "../../../Components/Items";

const { Text, Paragraph } = Typography;

const estadoInicial = {
  loading: false,
  estado: null,
  paso: "estado",
  uri: null,
  secreto: null,
  codigo: "",
  codigosRespaldo: [],
  confirmarApagar: false,
  regenerar: false,
  alcancePendiente: null,
};

class ModalDosPasos extends Component {
  state = { ...estadoInicial };

  componentDidUpdate(prevProps) {
    if (this.props.visible && !prevProps.visible) {
      this.setState({ ...estadoInicial });
      this.consultarEstado();
    }
  }

  peticion(ruta, datos = {}) {
    this.setState({ loading: true });
    return axios
      .post(`dosPasos/${ruta}`, datos, { headers: this.props.headersToken })
      .then((res) => {
        this.setState({ loading: false });
        if (res.data.success === 2) return res.data;
        message.error(res.data.message || "Ocurrió un error, inténtalo de nuevo");
        return null;
      })
      .catch(() => {
        this.setState({ loading: false });
        message.error("Error de conexión");
        return null;
      });
  }

  consultarEstado() {
    this.peticion("estado").then((data) => data && this.setState({ estado: data.estado }));
  }

  iniciar() {
    this.peticion("iniciar").then((data) => data && this.setState({ paso: "configurar", uri: data.uri, secreto: data.secreto, codigo: "" }));
  }

  confirmar() {
    this.peticion("confirmar", { codigo: this.state.codigo }).then((data) => {
      if (!data) return;
      message.success("Verificación en dos pasos activada");
      this.setState({ paso: "codigos", estado: data.estado, codigosRespaldo: data.codigosRespaldo, codigo: "", uri: null, secreto: null });
    });
  }

  cambiarRequerido(requerido) {
    if (!requerido) return this.setState({ confirmarApagar: true, regenerar: false, codigo: "" });
    this.peticion("cambiarRequerido", { requerido: true }).then((data) => {
      if (!data) return;
      message.success("Se pedirá el código de verificación");
      this.setState({ estado: data.estado });
    });
  }

  apagar() {
    this.peticion("cambiarRequerido", { requerido: false, codigo: this.state.codigo }).then((data) => {
      if (!data) return;
      message.warning("Ya no se pedirá el código de verificación");
      this.setState({ estado: data.estado, confirmarApagar: false, codigo: "" });
    });
  }

  cambiarAlcance(alcance, codigo) {
    this.peticion("cambiarAlcance", { alcance, codigo }).then((data) => {
      if (!data) return;
      message.success("Opción guardada");
      this.setState({ estado: data.estado, alcancePendiente: null, codigo: "" });
    });
  }

  elegirAlcance(alcance) {
    const { estado } = this.state;
    const incluye = (valor, superficie) => valor === "ambos" || valor === superficie;
    const quitaProteccion = ["sistema", "ia"].some((superficie) => incluye(estado.alcance, superficie) && !incluye(alcance, superficie));
    if (quitaProteccion && estado.activo) return this.setState({ alcancePendiente: alcance, confirmarApagar: false, regenerar: false, codigo: "" });
    this.cambiarAlcance(alcance);
  }

  regenerarCodigos() {
    this.peticion("regenerarCodigos", { codigo: this.state.codigo }).then((data) => {
      if (!data) return;
      this.setState({ paso: "codigos", estado: data.estado, codigosRespaldo: data.codigosRespaldo, regenerar: false, codigo: "" });
    });
  }

  quitarDispositivo(datos) {
    this.peticion("quitarDispositivo", datos).then((data) => {
      if (!data) return;
      message.success(datos.todos ? "Se quitaron todos los dispositivos" : "Dispositivo quitado");
      this.setState({ estado: data.estado });
    });
  }

  textoCodigos() {
    return `Códigos de respaldo de BIWO ERP (verificación en dos pasos)\n\n${this.state.codigosRespaldo.join("\n")}\n\nCada código sirve una sola vez.`;
  }

  copiarCodigos() {
    navigator.clipboard
      ?.writeText(this.textoCodigos())
      .then(() => message.success("Códigos copiados"))
      .catch(() => message.error("No se pudieron copiar"));
  }

  descargarCodigos() {
    const url = URL.createObjectURL(new Blob([this.textoCodigos()], { type: "text/plain" }));
    const enlace = document.createElement("a");
    enlace.href = url;
    enlace.download = "biwo-codigos-respaldo.txt";
    enlace.click();
    URL.revokeObjectURL(url);
  }

  campoCodigo(placeholder, onEnter) {
    return (
      <InputItem
        placeholder={placeholder}
        value={this.state.codigo}
        maxLength={20}
        autoComplete="one-time-code"
        onChange={(e) => this.setState({ codigo: e.target.value })}
        onPressEnter={onEnter}
        style={{ textAlign: "center", fontSize: 18, letterSpacing: 4 }}
      />
    );
  }

  renderConfigurar() {
    return (
      <>
        <Paragraph>
          1. Abre Google Authenticator o Microsoft Authenticator en tu celular y escanea este código.
        </Paragraph>
        <div style={{ display: "flex", justifyContent: "center", marginBottom: 12 }}>
          <QRCode value={this.state.uri || "-"} size={200} />
        </div>
        <Paragraph type="secondary" style={{ textAlign: "center", fontSize: 12 }}>
          ¿No puedes escanearlo? Escribe esta clave en la app:
          <br />
          <Text copyable code>{this.state.secreto}</Text>
        </Paragraph>
        <Paragraph>2. Escribe el código de 6 dígitos que te muestra la app.</Paragraph>
        {this.campoCodigo("000000", () => this.confirmar())}
        <Row justify="end" gutter={8} style={{ marginTop: 16 }}>
          <Col>
            <ButtonItem rojo onClick={() => this.setState({ paso: "estado", codigo: "" })}>
              Cancelar
            </ButtonItem>
          </Col>
          <Col>
            <ButtonItem type="primary" onClick={() => this.confirmar()} disabled={!this.state.codigo.trim()}>
              Activar
            </ButtonItem>
          </Col>
        </Row>
      </>
    );
  }

  renderCodigos() {
    return (
      <>
        <Alert
          type="warning"
          showIcon
          style={{ marginBottom: 16 }}
          message="Guarda tus códigos de respaldo"
          description="Solo se muestran esta vez. Si no tienes tu celular, puedes usar uno de estos códigos en lugar del de 6 dígitos. Cada código sirve una sola vez."
        />
        <Row gutter={[8, 8]} style={{ marginBottom: 16 }}>
          {this.state.codigosRespaldo.map((codigo) => (
            <Col span={12} key={codigo} style={{ textAlign: "center" }}>
              <Text code style={{ fontSize: 16 }}>{codigo}</Text>
            </Col>
          ))}
        </Row>
        <Row justify="end" gutter={8}>
          <Col>
            <ButtonItem cyan onClick={() => this.copiarCodigos()}>
              Copiar
            </ButtonItem>
          </Col>
          <Col>
            <ButtonItem cyan onClick={() => this.descargarCodigos()}>
              Descargar
            </ButtonItem>
          </Col>
          <Col>
            <ButtonItem type="primary" onClick={() => this.setState({ paso: "estado", codigosRespaldo: [] })}>
              Ya los guardé
            </ButtonItem>
          </Col>
        </Row>
      </>
    );
  }

  renderEstado() {
    const { estado, confirmarApagar, regenerar, alcancePendiente } = this.state;
    if (!estado) return null;

    return (
      <>
        <div style={estado.requerido ? undefined : { opacity: 0.45, pointerEvents: "none", userSelect: "none" }}>
        <Row justify="end" style={{ marginTop: 12 }}>
          {estado.activo ? (
            <ButtonItem cyan onClick={() => this.setState({ regenerar: !regenerar, confirmarApagar: false, codigo: "" })}>
              Generar nuevos códigos de respaldo
            </ButtonItem>
          ) : (
            <ButtonItem type="primary" onClick={() => this.iniciar()}>
              Configurar
            </ButtonItem>
          )}
        </Row>
        {regenerar && (
          <div style={{ marginTop: 12 }}>
            <Paragraph type="secondary">
              Los códigos anteriores dejarán de servir. Escribe el código de 6 dígitos de tu app para continuar.
            </Paragraph>
            {this.campoCodigo("000000", () => this.regenerarCodigos())}
            <Row justify="end" style={{ marginTop: 8 }}>
              <ButtonItem type="primary" onClick={() => this.regenerarCodigos()} disabled={!this.state.codigo.trim()}>
                Generar
              </ButtonItem>
            </Row>
          </div>
        )}
        </div>
        <div style={estado.requerido ? undefined : { opacity: 0.45, pointerEvents: "none", userSelect: "none" }}>
          <Paragraph>
            Agrega una capa extra de seguridad a tu cuenta: además de tu contraseña, se te pedirá un código que genera tu celular.
          </Paragraph>
          {estado.activo ? (
            <Alert
              type="success"
              showIcon
              message={`Activa desde el ${moment(estado.fechaActivacion).locale("es").format("LL")}`}
              description={`Te quedan ${estado.codigosRestantes} códigos de respaldo.`}
            />
          ) : (
            <Alert
              type={estado.requerido ? "warning" : "info"}
              showIcon
              message="No configurada"
              description="Configúrala escaneando el código QR con Google Authenticator o Microsoft Authenticator."
            />
          )}
        </div>
        {estado.activo && (
          <>
            <Divider style={{ margin: "16px 0" }} />
            <Row align="middle" justify="space-between" style={{ marginBottom: 8 }}>
              <Text strong>Dispositivos de confianza</Text>
              {estado.dispositivos.length > 0 && (
                <Popconfirm title="¿Quitar todos los dispositivos? Se pedirá el código en el siguiente inicio de sesión." onConfirm={() => this.quitarDispositivo({ todos: true })} okText="Si" cancelText="No">
                  <ButtonItem rojo size="small">Quitar todos</ButtonItem>
                </Popconfirm>
              )}
            </Row>
            {estado.dispositivos.length === 0 ? (
              <Text type="secondary" style={{ fontSize: 12 }}>
                Ninguno. Al iniciar sesión puedes marcar "Confiar en este dispositivo" para no escribir el código por 30 días.
              </Text>
            ) : (
              estado.dispositivos.map((dispositivo) => (
                <Row key={dispositivo.id} align="middle" justify="space-between" wrap={false} gutter={8} style={{ padding: "6px 0", borderBottom: "1px solid #f0f0f0" }}>
                  <Col flex="auto" style={{ minWidth: 0 }}>
                    <div style={{ fontWeight: 600, fontSize: 13 }}>{dispositivo.nombre}</div>
                    <div style={{ color: "#888", fontSize: 12 }}>
                      {`IP ${dispositivo.ip || "-"} · Último uso ${moment(dispositivo.ultimoUso).locale("es").format("lll")} · Vence ${moment(dispositivo.expira).locale("es").format("ll")}`}
                    </div>
                  </Col>
                  <Col>
                    <Popconfirm title="¿Quitar este dispositivo?" onConfirm={() => this.quitarDispositivo({ id: dispositivo.id })} okText="Si" cancelText="No">
                      <Tooltip title="Quitar" placement="top" overlayInnerStyle={{ fontSize: "10px", padding: "1px 5px", minHeight: "auto" }}>
                        <ButtonItem type="default" size="small" rojo icon={<DeleteOutlined />} />
                      </Tooltip>
                    </Popconfirm>
                  </Col>
                </Row>
              ))
            )}
          </>
        )}
        <Divider style={{ margin: "16px 0" }} />
        <Row align="middle" justify="space-between" wrap={false} gutter={12}>
          <Col flex="auto">
            <Text strong>Pedir código de verificación</Text>
          </Col>
          <Col>
            <SwitchItem checked={estado.requerido && !confirmarApagar} onChange={(valor) => this.cambiarRequerido(valor)} disabled={confirmarApagar} />
          </Col>
        </Row>
        <div style={estado.requerido ? undefined : { opacity: 0.45, pointerEvents: "none", userSelect: "none" }}>
        <div style={{ marginTop: 12 }}>
          <Text strong>Dónde se pide el código</Text>
          <div className="dos-pasos-opciones">
            {[
              { valor: "ambos", titulo: "Sistema y IA´s", detalle: "Al iniciar sesión y al conectar" },
              { valor: "sistema", titulo: "Solo sistema", detalle: "Solo al iniciar sesión en BIWO" },
              { valor: "ia", titulo: "Solo IA´s", detalle: "Solo al conectar a IA´s" },
            ].map((opcion) => (
              <div  
                key={opcion.valor}
                className={"dos-pasos-opcion" + ((alcancePendiente || estado.alcance) === opcion.valor ? " dos-pasos-opcion-activa" : "")}
                onClick={() => this.elegirAlcance(opcion.valor)}
              >
                <b>{opcion.titulo}</b>
                <span>{opcion.detalle}</span>
              </div>
            ))}
          </div>
        </div>
        {alcancePendiente && (
          <div style={{ marginTop: 12 }}>
            <Paragraph type="secondary">Escribe el código de 6 dígitos de tu app para confirmar el cambio.</Paragraph>
            {this.campoCodigo("000000", () => this.cambiarAlcance(alcancePendiente, this.state.codigo))}
            <Row justify="end" gutter={8} style={{ marginTop: 8 }}>
              <Col>
                <ButtonItem cyan onClick={() => this.setState({ alcancePendiente: null, codigo: "" })}>Cancelar</ButtonItem>
              </Col>
              <Col>
                <ButtonItem type="primary" onClick={() => this.cambiarAlcance(alcancePendiente, this.state.codigo)} disabled={!this.state.codigo.trim()}>
                  Confirmar
                </ButtonItem>
              </Col>
            </Row>
          </div>
        )}
        </div>
        {confirmarApagar && (
          <div style={{ marginTop: 12 }}>
            <Alert
              type="error"
              showIcon
              message="Riesgo de seguridad"
              description="Si la apagas, cualquier persona que conozca tu contraseña podrá entrar a tu cuenta sin el código de verificación."
              style={{ marginBottom: 12 }}
            />
            {estado.activo && (
              <>
                <Paragraph type="secondary">Escribe el código de 6 dígitos de tu app para confirmar.</Paragraph>
                {this.campoCodigo("000000", () => this.apagar())}
              </>
            )}
            <Row justify="end" gutter={8} style={{ marginTop: 8 }}>
              <Col>
                <ButtonItem cyan onClick={() => this.setState({ confirmarApagar: false, codigo: "" })}>
                  Mantener protección
                </ButtonItem>
              </Col>
              <Col>
                <ButtonItem rojo onClick={() => this.apagar()} disabled={estado.activo && !this.state.codigo.trim()}>
                  Apagar
                </ButtonItem>
              </Col>
            </Row>
          </div>
        )}
      </>
    );
  }

  render() {
    const { paso, loading } = this.state;
    return (
      <ModalItem
        title={
          <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between", paddingRight: 24 }}>
            <span>
              <SafetyCertificateOutlined style={{ marginRight: 8 }} />
              Verificación en dos pasos
            </span>
            <BotonAyudaManuales modulo="dosPasos" size="small" />
          </div>
        }
        visible={this.props.visible}
        spinning={loading}
        onCancel={this.props.onCancel}
        width={460}
        paddingTop
        maskClosable={paso !== "codigos"}
        closable={paso !== "codigos"}
        keyboard={paso !== "codigos"}
      >
        <div style={{ paddingBottom: 16 }}>
          {paso === "configurar" && this.renderConfigurar()}
          {paso === "codigos" && this.renderCodigos()}
          {paso === "estado" && this.renderEstado()}
        </div>
      </ModalItem>
    );
  }
}

const mapStateToProps = (state) => ({
  headersToken: state.user.headersToken,
});

export default connect(mapStateToProps)(ModalDosPasos);
